var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_recruit_task",
          attrs: {
            id: "modal-recruit-task",
            title: _vm.title,
            "modal-class": "custom-modal",
            size: "xl",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _vm.canEditRecruitJobPostings
                        ? _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-secondary mr-auto",
                              on: { click: _vm.handleJobPosting }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "search-plus" }
                              }),
                              _vm._v("\n          Создать объявление\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.loading || _vm.isDisabled },
                          on: { click: _vm.handleOk }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n          Сохранить\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "mt-2 mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "xl" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "4%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "31%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "18%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "ml-auto mr-5",
                                    attrs: { cols: "auto" }
                                  },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "180%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "200%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "11%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "pt-2 d-flex justify-content-end align-items-center",
                                    attrs: { cols: "7" }
                                  },
                                  [
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "18%",
                                        height: "50%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "13%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "19%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "5" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "8%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "2" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "67%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-4" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "100%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mt-2" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex justify-content-end align-items-end"
                                  },
                                  [
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "12%",
                                        height: "80%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-2",
                            attrs: {
                              id: "group-location-select",
                              label: "Объект"
                            }
                          },
                          [
                            _c("location-select", {
                              ref: "location_select",
                              attrs: {
                                "is-disabled":
                                  _vm.isDisabled || _vm.isIntegrated,
                                value: _vm.newItem.location_id
                              },
                              on: { onSelect: _vm.onLocationChange }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "5" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group-opened-date",
                                      label: "Дата открытия вакансии"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        size: "sm",
                                        type: "date",
                                        disabled: _vm.isDisabled,
                                        placeholder: _vm.$t(
                                          "message.tasks.modal.start_datePlaceholder"
                                        ),
                                        state: _vm.getFieldState("opened_date")
                                      },
                                      model: {
                                        value: _vm.newItem.opened_date,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newItem,
                                            "opened_date",
                                            $$v
                                          )
                                        },
                                        expression: "newItem.opened_date"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "5" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group-closed-date",
                                      label: "Дата закрытия"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        size: "sm",
                                        type: "date",
                                        disabled: _vm.isDisabled,
                                        state: _vm.getFieldState("closed_date")
                                      },
                                      model: {
                                        value: _vm.newItem.closed_date,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newItem,
                                            "closed_date",
                                            $$v
                                          )
                                        },
                                        expression: "newItem.closed_date"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "d-flex justify-content-end",
                                attrs: { cols: "2", lg: "2", md: "3", sm: "3" }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group-urgency",
                                      label: "Срочно"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "px-2 pb-1 border-grey",
                                        attrs: { "no-body": "" }
                                      },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass: "mt-1",
                                            attrs: {
                                              disabled: _vm.isDisabled,
                                              size: "md",
                                              name: "urgency-checkbox"
                                            },
                                            model: {
                                              value: _vm.newItem.urgency,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "urgency",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.urgency"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.newItem.urgency
                                                    ? "Да"
                                                    : "Нет"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-collapse-group my-4" },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName:
                                      "v-b-toggle.collapse-vacancy-table",
                                    modifiers: {
                                      "collapse-vacancy-table": true
                                    }
                                  }
                                ],
                                staticClass: "custom-collapse-header",
                                attrs: { role: "button" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center w-100"
                                  },
                                  [
                                    _c(
                                      "h6",
                                      {
                                        staticClass:
                                          "text-small text-muted mb-0 mr-3"
                                      },
                                      [_vm._v("ВАКАНСИЯ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mr-3",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                          }
                                        }
                                      },
                                      [
                                        _c("location-vacancy-select", {
                                          ref: "location_vacancy_select",
                                          staticClass: "mr-3",
                                          attrs: {
                                            "is-disabled": _vm.isDisabled,
                                            "location-id":
                                              _vm.newItem.location_id,
                                            "location-name":
                                              _vm.newItem.location_name,
                                            value:
                                              _vm.newItem.location_vacancy_id,
                                            "initial-text":
                                              _vm.newItem.location_vacancy_name,
                                            state: _vm.getFieldState(
                                              "location_vacancy_id"
                                            )
                                          },
                                          on: { onSelect: _vm.onVacancyChange }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-icon", {
                                      staticClass: "chevron-icon",
                                      attrs: {
                                        name: "buttons/collapse_chevrons_down",
                                        size: 13
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  id: "collapse-vacancy-table",
                                  visible: ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "custom-collapse-body" },
                                  [
                                    _c("location-vacancies", {
                                      ref: "recruit_vacancy",
                                      attrs: {
                                        "show-details": "",
                                        "is-disabled": _vm.isDisabled,
                                        "local-items": [_vm.newItem]
                                      },
                                      on: {
                                        close: function($event) {
                                          _vm.isVacancyOpen = false
                                        },
                                        "config-updated":
                                          _vm.onVacancyConfigUpdate
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-collapse-group mt-4" },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName:
                                      "v-b-toggle.collapse-contacts-table",
                                    modifiers: {
                                      "collapse-contacts-table": true
                                    }
                                  }
                                ],
                                staticClass: "custom-collapse-header",
                                attrs: { role: "button" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c(
                                      "h6",
                                      {
                                        staticClass:
                                          "text-small text-muted mb-0 mr-3"
                                      },
                                      [_vm._v("КОНТАКТЫ")]
                                    ),
                                    _vm._v(" "),
                                    _c("v-icon", {
                                      staticClass: "chevron-icon",
                                      attrs: {
                                        name: "buttons/collapse_chevrons_down",
                                        size: 13
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  disabled: !_vm.newItem.location_vacancy_id,
                                  id: "collapse-contacts-table",
                                  visible: ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "custom-collapse-body" },
                                  [
                                    _c("location-contacts", {
                                      ref: "recruit_contacts",
                                      attrs: { "is-disabled": _vm.isDisabled },
                                      on: {
                                        close: function($event) {
                                          _vm.isContactsOpen = false
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "align-items-end" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "6" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-2",
                                    attrs: {
                                      id: "group-members",
                                      label: "Участники"
                                    }
                                  },
                                  [
                                    _c("user-multi-select", {
                                      ref: "members_select",
                                      attrs: {
                                        "is-disabled": _vm.noLocationDisabled,
                                        "user-items": _vm.locationUsers,
                                        value: _vm.newItem.members
                                      },
                                      on: { onSelect: _vm.onMembersSelect }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "6" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-2",
                                    attrs: {
                                      id: "group-assigned",
                                      label: "Ответственный"
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        size: "sm",
                                        disabled: _vm.noLocationDisabled,
                                        options: _vm.assignedOptions
                                      },
                                      model: {
                                        value: _vm.newItem.assigned,
                                        callback: function($$v) {
                                          _vm.$set(_vm.newItem, "assigned", $$v)
                                        },
                                        expression: "newItem.assigned"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                attrs: { cols: "4", lg: "5", md: "4", sm: "4" }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-2",
                                    attrs: { label: "Теги" }
                                  },
                                  [
                                    _c("recruit-tag-multi-select", {
                                      attrs: {
                                        value: _vm.newItem.tags,
                                        "is-disabled": _vm.isDisabled
                                      },
                                      on: { onSelect: _vm.onTagsSelected }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                attrs: { cols: "4", lg: "5", md: "5", sm: "5" }
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group-status",
                                      label: "Статус"
                                    }
                                  },
                                  [
                                    _c("recruit-task-status-select", {
                                      attrs: {
                                        "is-disabled": _vm.isDisabled,
                                        value: _vm.newItem.status_id
                                      },
                                      on: {
                                        onSelect: _vm.onSelectRecruitTaskStatus
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "group-budget",
                                      label: "Рекламный бюджет"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        type: "number",
                                        disabled: _vm.isDisabled,
                                        placeholder:
                                          "Введите планируемый бюджет"
                                      },
                                      model: {
                                        value: _vm.newItem.budget,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.newItem,
                                            "budget",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "newItem.budget"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            attrs: { id: "group-comment", label: "Комментарий" }
                          },
                          [
                            _c("b-form-textarea", {
                              staticClass: "mb-4",
                              attrs: {
                                disabled: _vm.isDisabled,
                                placeholder: _vm.$t(
                                  "message.organizations.modal.descriptionPlaceholder"
                                ),
                                rows: 3,
                                "max-rows": 6
                              },
                              model: {
                                value: _vm.newItem.comment,
                                callback: function($$v) {
                                  _vm.$set(_vm.newItem, "comment", $$v)
                                },
                                expression: "newItem.comment"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-collapse-group" },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.collapse-media",
                                    modifiers: { "collapse-media": true }
                                  }
                                ],
                                staticClass: "custom-collapse-header",
                                attrs: { role: "button" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c(
                                      "h6",
                                      {
                                        staticClass:
                                          "text-small text-muted mb-0 mr-3"
                                      },
                                      [_vm._v("МЕДИАФАЙЛЫ")]
                                    ),
                                    _vm._v(" "),
                                    _c("v-icon", {
                                      staticClass: "chevron-icon",
                                      attrs: {
                                        name: "buttons/collapse_chevrons_down",
                                        size: 13
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  disabled: !_vm.newItem.location_id,
                                  id: "collapse-media",
                                  visible: ""
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "custom-collapse-body" },
                                  [
                                    _c("location-media", {
                                      ref: "recruit_media",
                                      staticClass: "mx-2",
                                      attrs: {
                                        "location-id": _vm.newItem.location_id,
                                        "is-disabled": _vm.isDisabled
                                      },
                                      on: {
                                        close: function($event) {
                                          _vm.isMediaOpen = false
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88c98b70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88c98b70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitTask.vue
// module id = null
// module chunks = 